import React from "react";
import {
  SiGo,
  SiTypescript,
  SiDelphi,
  SiExpress,
  SiClojure,
  SiPostgresql,
  SiMongodb,
  SiRedis,
  SiReact,
  SiNextdotjs,
  SiTailwindcss,
  SiGooglecloud,
  SiGithubcopilot,
  SiClaude,
} from "react-icons/si";
import { FaJava, FaAws, FaDocker, FaRobot } from "react-icons/fa";
import { VscAzure } from "react-icons/vsc";
import { useLanguage } from "../LanguageContext";
import useScrollReveal from "../../utils/useScrollReveal";

import "../../assets/css/expertise.css";
import "../../assets/css/font.css";

function Expertise() {
  const { t } = useLanguage();
  const [ref, visible] = useScrollReveal();

  const categories = [
    {
      key: "backend",
      items: [
        { icon: SiGo, label: "Go" },
        { icon: SiClojure, label: "Clojure" },
        { icon: SiTypescript, label: "TypeScript" },
        { icon: FaJava, label: "Java" },
        { icon: SiDelphi, label: "Delphi" },
        { icon: SiExpress, label: "Express" },
      ],
    },
    {
      key: "cloud",
      items: [
        { icon: FaAws, label: "AWS" },
        { icon: VscAzure, label: "Azure" },
        { icon: SiGooglecloud, label: "GCP" },
        { icon: FaDocker, label: "Docker" },
      ],
    },
    {
      key: "data",
      items: [
        { icon: SiPostgresql, label: "PostgreSQL" },
        { icon: SiMongodb, label: "MongoDB" },
        { icon: SiRedis, label: "Redis" },
      ],
    },
    {
      key: "frontend",
      items: [
        { icon: SiReact, label: "React" },
        { icon: SiNextdotjs, label: "Next.js" },
        { icon: SiTailwindcss, label: "Tailwind CSS" },
      ],
    },
    {
      key: "ai",
      items: [
        { icon: SiGithubcopilot, label: "GitHub Copilot" },
        { icon: SiClaude, label: "Claude Code" },
        { icon: FaRobot, label: "LLM APIs" },
      ],
    },
  ];

  return (
    <section
      ref={ref}
      className={`section section-alt expertise reveal ${visible ? "is-visible" : ""}`}
    >
      <div className="container">
        <span className="eyebrow">{t.expertise.eyebrow}</span>
        <h2 className="section-heading section-intro">{t.expertise.title}</h2>

        <div className="expertise-grid">
          {categories.map((category) => (
            <div className="expertise-category" key={category.key}>
              <h3 className="mono">{t.expertise.categories[category.key]}</h3>
              <ul>
                {category.items.map(({ icon: Icon, label }) => (
                  <li key={label}>
                    <Icon aria-hidden="true" />
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Expertise;
